<!-- 控销-商品管理 -->
<template>
  <div class="classification">
    <div class="header">
      <!-- <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">
        <el-form-item prop="id" label="">
          <el-input v-model="formTool.id" placeholder="请输入商品ID" clearable size="small" />
        </el-form-item> 
      </el-form> -->
      <el-button size="small" type="primary" @click="detailHandle({}, 'add')">新增召回商品</el-button>
    </div>

    <div class="center" style="position: relative">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
        :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange">
        <!-- <template slot="image" slot-scope="scope">
          <el-row>
            <el-col style="width:100px">
              <el-image :src="scope.row.image
                ? scope.row.image
                : avater
                " lazy style="width: 100px; height: 100px" />
            </el-col>
            <el-col   style="width:calc(100% - 110px);margin-left:10px">

              <el-row> {{ scope.row.name }} </el-row> 
              <el-row>
                {{ scope.row.factory }}
              </el-row>
              <el-row>
                {{ scope.row.specification }}
              </el-row>
              <el-row>
                {{ scope.row.approvalNumber }}
              </el-row>
              
            </el-col>
          </el-row>
        </template> -->

        <template slot="menu" slot-scope="scope" style="width: 300px;">
          <div class="btn-warp">
            <el-link :underline="false" type="primary" @click="detailHandle(scope.row, 'detail')"
              class="btn-list">查看</el-link>
            <el-link :underline="false" type="danger" @click="detailHandle(scope.row, 'delete')"
              class="btn-list">删除</el-link>
          </div>
        </template>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]" layout="sizes, prev, pager, next" :total="page.total">
        </el-pagination>

      </MyTable>
    </div>
    <goodsDialog :dialogShow="dialogShow" :btnType="btnType" ref="goods-dailog" @didSelectItem="didSelectItem" />
    <goodsSettingDialog ref="goods-setting-dailog" @getList="getList" />

  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import goodsDialog from "./components/controlSalesGoodsDialog.vue";
import { mapGetters } from 'vuex'
import goodsSettingDialog from "./components/settingGoodsDialog.vue";

import {
  messageRecallQuery,messageRecallDelete
} from "@/api/product";

import avater from "/public/img/default.png";

export default {
  components: {
    MyTable, goodsDialog,
    goodsSettingDialog
  },
  data() {
    return {
      avater: avater,
      formTool: {

      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [{ id: 1 }],
      tableOption: [
        { label: "商品名称", prop: "goodsName", minWidth: '230px' },
        { label: "生产厂家", prop: "factory" },
        { label: "发布人", prop: "createBy" },
        // { label: "发布用户名", prop: "createBy"  },
        { label: "发布时间", prop: "createTime" },
      ],
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      dialogShow: false
    };
  },
  computed: {},
  watch: {},
  created() {
  },

  mounted() {
    this.getList();
  },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    didSelectItem(row) {
      // 选择商品
      this.$refs['goods-setting-dailog'].init(row, 'add')
    },
    // 页码变化
    handleCurrentChange(e) {
      this.page.current = e
      this.getList()
    },
    // 条数变化
    handleSizeChange(e) {
      this.page.size = e
      this.page.current = 1;
      this.getList()
    },

    detailHandle(row, btnType) {
      if (btnType == 'delete') {
        this.openMessageBox(row)
      }

      if (btnType == 'add') {
        this.$refs['goods-dailog'].init(row, btnType)
      }

      if (btnType == 'detail') {
        this.$refs['goods-setting-dailog'].init(row, btnType)
      }
    },
    openMessageBox(data) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.removeRecall(data);
        })
        .catch(() => { });
    },
    removeRecall(row) { 
      messageRecallDelete({ id: row.id }).then((res) => {
        if (res) {
          this.$message.success('删除成功!')
          this.getList();
        }
      });
    },

    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList(1);
    },

    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 查询  列表
    getList(current) {

      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }

      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };
      messageRecallQuery(params).then((res) => {
        this.tableData = res.records;
        this.page.total = res.total;
        console.log(this.tableData)
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

    .el-link {
      // margin: 5px;
    }
  }
}
</style>
